import { isNewUser } from '../utils/externalData';

const useNewUser = () => {
  return isNewUser();
};

export default useNewUser;
